import {Dispatch} from "react";
import {
  clearNewsData,
  loadingRelatedData,
  loadTweetListsAfterDate,
  loadTweetRelatedAfterDate,
  loadTweetsListForCountry, loadTweetsListForRegion
} from "../../store/actions/tweets/tweet.actions";
import {RegionType} from "../../model/RegionType";
import {
  loadingTrendingData, loadTrendingTags, loadTrendingTagsCategoriesData, // loadTagsRegionTrendingList,
  /*loadTweetRegionTrendingList,*/ loadTweetTrendingHeadlines,
  loadTweetTrendingList, setTabState
} from "../../store/actions/trending/trending.actions";

export async function loadNewsInitial(dispatch: Dispatch<any>) {
  await dispatch(loadingRelatedData(true))
  await dispatch(clearNewsData())
  await dispatch(loadTweetListsAfterDate(null))
  await dispatch(loadingRelatedData(false))
}

export async function loadNews(date: number | null, dispatch: Dispatch<any>) {
  await dispatch(loadTweetListsAfterDate(date))
}

export async function loadRelatedNews(date: number | null, dispatch: Dispatch<any>) {
  await dispatch(loadTweetRelatedAfterDate(date))
}

export async function loadNewsForCountry(country: string, dispatch: Dispatch<any>) {
  await dispatch(loadingRelatedData(true))
  await dispatch(clearNewsData())
  await dispatch(loadTweetsListForCountry(country, null))
  await dispatch(loadingRelatedData(false))
}

export async function loadNewsForRegion(region: RegionType, dispatch: Dispatch<any>) {
  await dispatch(loadingRelatedData(true))
  await dispatch(clearNewsData())
  await dispatch(loadTweetsListForRegion(region, null))
  await dispatch(loadingRelatedData(false))
}

export async function loadMoreNewsForCountry(country: string, date: number | null, dispatch: Dispatch<any>) {
  await dispatch(loadTweetsListForCountry(country, date))
}

export async function loadMoreNewsForRegion(region: RegionType, date: number | null, dispatch: Dispatch<any>) {
  await dispatch(loadTweetsListForRegion(region, date))
}

export async function loadTrendingData(dispatch: Dispatch<any>) {
  await dispatch(loadTweetTrendingList())
}

export async function loadTrendingHeadlines(dispatch: Dispatch<any>) {
  await dispatch(loadTweetTrendingHeadlines())
}

export async function loadAllTagsData(dispatch: Dispatch<any>) {
    await dispatch(loadTrendingTags())
}

export async function loadAllTagsCategoryData(dispatch: Dispatch<any>) {
  await dispatch(loadTrendingTagsCategoriesData())
}

/*export async function loadTrendingRegionNewsData(dispatch: Dispatch<any>) {
  await dispatch(loadTweetRegionTrendingList())
}

export async function loadTrendingTagsData(dispatch: Dispatch<any>) {
  await dispatch(loadTagsRegionTrendingList())
}*/

export async function setTrendingDataLoadingFlag(dispatch: Dispatch<any>) {
  await dispatch(loadingTrendingData())
}

export async function setTabStateFlag(tab: number, dispatch: Dispatch<any>) {
  await dispatch(setTabState(tab))
}
